// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: auto;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--app-canvas);
}

.login-content {
  flex: 1;
  display: grid;
  place-items: center;
  padding: 24px 16px;
}

.login-card {
  display: block;
  width: 100%;
  max-width: 400px;
  min-width: 0;
  padding: 6px 15px;
  border-radius: 8px;
}

.login-brand {
  display: block;
  width: 280px;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.login-form {
  display: flex;
  flex-direction: column;
  padding: 0 8px 18px;
}

.login-form mat-form-field {
  width: 100%;
}

.login-submit {
  margin: 8px 0 20px;
}

`, "",{"version":3,"sources":["webpack://./src/app/main/login/login.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[":host {\n  width: 100%;\n  height: auto;\n  min-height: 100vh;\n  min-height: 100dvh;\n  background: var(--app-canvas);\n}\n\n.login-content {\n  flex: 1;\n  display: grid;\n  place-items: center;\n  padding: 24px 16px;\n}\n\n.login-card {\n  display: block;\n  width: 100%;\n  max-width: 400px;\n  min-width: 0;\n  padding: 6px 15px;\n  border-radius: 8px;\n}\n\n.login-brand {\n  display: block;\n  width: 280px;\n  max-width: 100%;\n  height: auto;\n  margin: 0 auto;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  padding: 0 8px 18px;\n}\n\n.login-form mat-form-field {\n  width: 100%;\n}\n\n.login-submit {\n  margin: 8px 0 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
